import { render, staticRenderFns } from "./iframePage.vue?vue&type=template&id=4cd6a45f"
import script from "./iframePage.vue?vue&type=script&lang=js"
export * from "./iframePage.vue?vue&type=script&lang=js"
import style0 from "./iframePage.vue?vue&type=style&index=0&id=4cd6a45f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports